// extracted by mini-css-extract-plugin
module.exports = {"container":"SavingValidation_container__3M-cc","spinner":"SavingValidation_spinner__3U2rP","text":"SavingValidation_text__3DEqZ"};